import React from 'react';

import ProgramSection from '../../components/ProgramSection';

function Corporate() {
  return (
    <ProgramSection
      category="corporate"
      breadcrumb="Corporate"
      titlePlain="Corporate"
      titleAccent="Programs"
      subtitle="Financial wellness programs we have delivered for organizations — empowering employees with essential financial knowledge and skills."
    />
  );
}

export default Corporate;
